import { render } from "./AddTranscoderModal.vue?vue&type=template&id=50056650&scoped=true"
import script from "./AddTranscoderModal.vue?vue&type=script&lang=js"
export * from "./AddTranscoderModal.vue?vue&type=script&lang=js"

import "./AddTranscoderModal.vue?vue&type=style&index=0&id=50056650&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50056650"],['__file',"src/components/modals/AddTranscoderModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50056650"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50056650', __exports__)) {
    api.reload('50056650', __exports__)
  }
  
  module.hot.accept("./AddTranscoderModal.vue?vue&type=template&id=50056650&scoped=true", () => {
    api.rerender('50056650', render)
  })

}


export default __exports__